export default "__VITE_ASSET__efC8I6WQ__"